var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"border"},[_c('div',{staticStyle:{"padding":"1rem"}},[_c('PageHeader',{attrs:{"title":"อันดับนักเรียน"}}),_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('studentRanking',{attrs:{"apiRoute":`/v1/analytics/courses/getCourseStudentRanking?cId=${_vm.cId}&template=A`,"perPage":20}})],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }